<template>
  <div class="tw-flex tw-flex-col tw-gap-4 tw-mb-4">
    <div
      :data-test-id="`msp-branding-logo-${mode}-image-preview-details`"
      class="tw-flex tw-flex-row tw-gap-1 tw-w-full tw-justify-center tw-rounded tw-border tw-border-primary-grey-100 tw-py-2 tw-px-3"
    >
      <div class="tw-grow tw-flex tw-flex-col tw-gap-1 tw-items-start">
        <div
          class="tw-font-medium tw-text-lg"
          :data-test-id="`msp-branding-${mode}-light-image-preview-details-image-name`"
        >
          {{ fileName }}
        </div>
        <div
          class="tw-flex tw-flex-grow-0 tw-items-center tw-font-normal tw-text-sm"
        >
          <span
            :data-test-id="`msp-branding-logo-${mode}-image-preview-details-image-size`"
            >{{ formatBytes(fileSize) }}</span
          >
        </div>
      </div>
      <div v-if="!props.readonly" class="tw-shrink tw-flex tw-items-center">
        <cl-table-action-button
          :data-test-id="`msp-branding-logo-${mode}-image-preview-delete-button`"
          @on-click="onRemoveUploadedFile"
        >
          <span><cb-icon-delete :width="24" /></span>
        </cl-table-action-button>
      </div>
    </div>

    <div
      :data-test-id="`msp-branding-logo-${mode}-image-preview-in-different-mode`"
      class="tw-flex tw-flex-row tw-gap-1 tw-w-full tw-items-start tw-justify-center tw-rounded tw-border tw-border-primary-grey-100 tw-py-2 tw-px-3"
      :class="{
        'tw-bg-[#202020]': mode === 'dark',
        'tw-bg-[#f2f4f5]': mode === 'light',
      }"
    >
      <img
        v-if="props.src"
        :src="props.src"
        :alt="props.fileName"
        class="tw-mt-2 tw-max-h-40 tw-object-contain tw-object-center tw-w-[380px] tw-h-[100px]"
        data-clarity-mask="true"
      />
    </div>
  </div>
</template>

<script lang="ts">
interface Props {
  src: string | null;
  fileName: string;
  fileSize: number;
  mode: "light" | "dark";
  readonly?: boolean;
}
</script>

<script setup lang="ts">
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

import { formatBytes } from "@/utils/formatBytes";

dayjs.extend(duration);

const emit = defineEmits<{
  (
    event: "remove-file",
    value: { fileName: string; mode: "light" | "dark" },
  ): void;
}>();

const props = defineProps<Props>();

const onRemoveUploadedFile = () => {
  emit("remove-file", {
    fileName: props.fileName,
    mode: props.mode,
  });
};
</script>
